import { NgModule } from '@angular/core';
import { AGENTS_ROUTES } from './agents.routes';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '../shared/shared.module';
import { AnalyticsComponent } from './analytics/analytics.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { MarkdownsComponent } from './markdowns/markdowns.component';
import { ConversationsComponent } from './conversations/conversations.component';
import { AgentsComponent } from './agents.component';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { AgentConfigurationComponent } from './configuration/agent/agent-configuration.component';
import { LabelModule } from '@progress/kendo-angular-label';
import { GridModule } from '@progress/kendo-angular-grid';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { ChatModule } from '@progress/kendo-angular-conversational-ui';
import { DropDownListComponent, MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { LMarkdownEditorModule } from 'ngx-markdown-editor';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { NotificationModule, NotificationService } from '@progress/kendo-angular-notification';
import { DialogModule, DialogService } from '@progress/kendo-angular-dialog';
import { AiApiHeaderInterceptor } from './shared/ai-api.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MarkdownComponent, MarkdownModule, MarkdownService } from 'ngx-markdown';
import { InputsModule } from '@progress/kendo-angular-inputs';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AGENTS_ROUTES),
    SharedModule,
    NgSelectModule,
    TabStripModule,
    LabelModule,
    GridModule,
    ToolBarModule,
    ChatModule,
    MultiSelectModule,
    LMarkdownEditorModule,
    ButtonGroupModule,
    NotificationModule,
    DialogModule,
    MarkdownModule.forChild(),
    MarkdownComponent,
    InputsModule,
    ButtonsModule,
    DropDownListComponent,
  ],
  declarations: [
    AgentsComponent,
    AgentConfigurationComponent,
    AnalyticsComponent,
    ConfigurationComponent,
    MarkdownsComponent,
    ConversationsComponent
  ],
  providers: [
    NotificationService,
    DialogService,
    MarkdownService,
    { provide: HTTP_INTERCEPTORS, useClass: AiApiHeaderInterceptor, multi: true },
  ]
})
export class AgentsModule { }
